module.exports = __webpack_public_path__ + "img/about.6115f353.svg";